/*
 * Keeps the clicked <summary> at the same viewport y-position when a sibling
 * <details> in the same `name=""` group closes. Native disclosure groups
 * (Chrome/Safari) close the previously-open item but leave the page's scroll
 * position unchanged in document coordinates, which can push the row the user
 * clicked far up or down on screen when the closing item is tall.
 *
 * Scoped to AW disclosure items (aw-faq and aw-step-faq).
 */
(function () {
  if (window.__awDisclosureAnchor) return;
  window.__awDisclosureAnchor = true;

  var SELECTOR = '.aw-faq__item > summary, .aw-step-faq__item > summary';

  document.addEventListener('click', function (e) {
    var summary = e.target.closest && e.target.closest(SELECTOR);
    if (!summary) return;

    var item = summary.parentElement;
    if (!item || item.tagName !== 'DETAILS') return;

    // Only need to compensate when opening a closed item that belongs to a
    // group with another item currently open (which the browser will close).
    if (item.open) return;
    var name = item.getAttribute('name');
    if (!name) return;
    var escaped = window.CSS && CSS.escape ? CSS.escape(name) : name;
    var openSiblings = document.querySelectorAll('details[name="' + escaped + '"][open]');
    if (openSiblings.length === 0) return;

    var beforeTop = summary.getBoundingClientRect().top;
    requestAnimationFrame(function () {
      var afterTop = summary.getBoundingClientRect().top;
      var delta = afterTop - beforeTop;
      if (delta !== 0) {
        window.scrollBy(0, delta);
      }
    });
  });
})();
